module.exports = __webpack_public_path__ + "media/images/favicon-9fe31e47e2b951eb49d7b4f8ab9f1c5a.ico";